import type { FC, PropsWithChildren } from 'react'
import styled from '@emotion/styled'

import Button from '@segment/matcha/components/Button'

import * as CopyText from '@segment/matcha/recipes/CopyText'
import HeroBase, * as HeroRecipe from '@segment/matcha/recipes/Hero'

import type { EventCard } from '@segment/api/routes/customerSuccessEvent/queries'

import getAbsoluteUrl from '@segment/utils/getAbsoluteUrl'

import { usePageConfig } from '@segment/contexts/page'

import FeaturedCard from './FeaturedCard'
import HeroImage from './HeroImage'

interface HeroProps {
  data: EventCard | null
}

const copy = {
  heading: `Customer Success Events`,
  description: `Customer-focused, interactive, and educational events by Segment practitioners, for Segment practitioners.`,
}

const pastWebinarsLink = {
  text: `See past webinars`,
  href: `#past-webinars`,
}

const Hero: FC<PropsWithChildren<HeroProps>> = ({ data }) => {
  const pageConfig = usePageConfig()
  return (
    <Wrapper>
      <HeroBase variant="2Col">
        <StyledHeroRecipeCopy>
          <CopyText.Heading variant="h1" tag="h1">
            {copy.heading}
          </CopyText.Heading>
          <CopyText.Description variant="pExtraLarge" tag="p">
            {copy.description}
          </CopyText.Description>
          <Button
            size="large"
            variant="outlined"
            tag="a"
            color="primary"
            href={getAbsoluteUrl(pastWebinarsLink.href, pageConfig)}
          >
            {pastWebinarsLink.text}
          </Button>
        </StyledHeroRecipeCopy>

        <HeroRecipe.Contents>{data ? <FeaturedCard data={data} /> : <HeroImage />}</HeroRecipe.Contents>
      </HeroBase>
    </Wrapper>
  )
}

const StyledHeroRecipeCopy = styled(HeroRecipe.Copy)`
  ${({ theme }) => theme.breakpoints.down(`md`)} {
    text-align: left;
  }
`

const Wrapper = styled.header`
  background-color: ${({ theme }) => theme.palette.twilio.green[10]};
`

export default Hero
